import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { Dialog,  DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Toolbar, ToolbarItem, ToolbarSeparator, ToolbarSpacer,Button, DropDownButton } from "@progress/kendo-react-buttons";
import { Form as KendoForm, FormElement, Field } from "@progress/kendo-react-form";
import { FormDropDownListById, FormInput } from "../forms/form-components";
import { iconsData } from "../lib/utils";
import i18next from "i18next";
import { useTranslation } from "react-i18next";


export const MenuDesigner = props => {
    const { 
        groups, reports, 
        onGroupExpandToggle, 
        addGroupState, onAddGroup, onAddGroupValueChange, onAddGroupValidate, onAddGroupSave, onAddGroupEdit, onAddGroupClose, 
        onRemoveGroup, onAddItem, onRearrange, onDrop, onRemoveReport,
        ...others
    } = props;

    const { t } = useTranslation();
    const currentTheme = useSelector(state => state.currentTheme);

    const iconItemRenderer = (li, itemProps) => {
        let dataItem = itemProps.dataItem;

        const index = itemProps.index;
        const itemChildren = (
            <div key={dataItem.Id} style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <div className={`k-icon ${dataItem.Icon}`}></div>
                <div style={{marginLeft:10}}>{dataItem.Title}</div>
            </div>
        //   <span
        //     style={{
        //       color: "#00F",
        //     }}
        //   >
        //     {li.props.children} {index}
        //   </span>
        );
        return React.cloneElement(li, li.props, itemChildren);
      };

      const iconValueRenderer = (element, value) => {
        if (!value) 
          return element;
        

        const children = [
            <div key={value.Icon} style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <div className={`k-icon ${value.Icon}`}></div>
                <div style={{marginLeft:10}}>{value.Title}</div>
            </div>
        ];

        return React.cloneElement(
          element,
          {
            ...element.props,
          },
          children
        );
      };

    return (
        <Fragment>
            <div className="menu-designer">
                <div className="groups">
                    <div className="groups-inner">
                        <div className="header">
                            <div className="title">{t("menudesigner.groups")}</div>
                            <div className="add-group" onClick={onAddGroup}>{t("menudesigner.addgroup")}</div>
                        </div>
                        <div className="groups-container">
                        {
                            groups.map((group, index) => {
                                return (
                                    <div key={group.Id} className="group-container">
                                        <div className="group-row" 
                                            draggable="true" 
                                            onDragStart={e => {
                                                e.dataTransfer.setData("sourceType", "group");
                                                e.dataTransfer.setData("groupId", group.Id);
                                                e.dataTransfer.setData("groupTitle", group.Title);
                                            }}

                                            onDragOver={e => e.preventDefault()} 
                                            onDrop={e => {
                                                e.preventDefault();

                                                let sourceType = e.dataTransfer.getData("sourceType");
                                                if (sourceType == "rightReport")
                                                {
                                                    //add source report to the end of the target group 
                                                    let reportId = e.dataTransfer.getData("reportId");
                                                    let reportTitle = e.dataTransfer.getData("reportTitle");
                                                    let reportReferenceKey = e.dataTransfer.getData("reportReferenceKey");

                                                    onDrop({type: 1, reportId: reportId, reportTitle: reportTitle, groupId: group.Id, reportReferenceKey: reportReferenceKey});
                                                }
                                                else if (sourceType == "group")
                                                {
                                                    //reorder group
                                                    let groupId = e.dataTransfer.getData("groupId");
                                                    let groupTitle = e.dataTransfer.getData("groupTitle");

                                                    onDrop({type: 2, sourceGroupId: groupId, sourceGroupTitle: groupTitle, targetGroupId: group.Id});
                                                }
                                            }}>
                                            <div className={`k-icon ${group.Icon}`} style={{marginTop: 8, color: currentTheme.primary}}></div>
                                            <div className="title">{group.Title}</div>
                                            <div className="toggle-group" style={{marginLeft:16}}>
                                                <Button className="" style={{color: currentTheme.primary}} icon={group.IsExpanded ? "minus" : "plus"} fillMode="flat" onClick={e => onGroupExpandToggle(group.Id)} />
                                            </div>
                                            <div className="edit" style={{marginLeft: 6}}>
                                                <Button className="" style={{color: currentTheme.primary}} icon="edit" fillMode="flat" onClick={e => onAddGroupEdit(group.Id, group.Title, group.Icon)} />
                                            </div>
                                            <div className="remove">
                                                <Button className="" style={{color: currentTheme.error}} icon="delete" fillMode="flat" onClick={e => onRemoveGroup(group.Id) } />
                                            </div>
                                        </div>
                                        {
                                            group.IsExpanded &&
                                            <div className="items-container">
                                            {                                           
                                                group.Items.map((item, index) => {
                                                    return (
                                                        <div key={item.Id} className="item-row" draggable="true" 
                                                        onDragStart={e => {
                                                            e.dataTransfer.setData("sourceType", "leftReport");
                                                            e.dataTransfer.setData("reportIdAuto", item.Id);
                                                            e.dataTransfer.setData("reportId", item.ReportId);
                                                            e.dataTransfer.setData("reportTitle", item.Title);
                                                            e.dataTransfer.setData("reportReferenceKey", item.ReferenceKey);
                                                            e.dataTransfer.setData("groupId", group.Id);
                                                        }}
            
                                                        onDragOver={e => e.preventDefault()} 
                                                        onDrop={e => {
                                                            e.preventDefault();
            
                                                            let sourceType = e.dataTransfer.getData("sourceType");
                                                            if (sourceType == "leftReport")
                                                            {
                                                                //reorder left report
                                                                let sourceReportIdAuto = e.dataTransfer.getData("reportIdAuto");
                                                                let sourceReportId = e.dataTransfer.getData("reportId");
                                                                let sourceReportTitle = e.dataTransfer.getData("reportTitle");
                                                                let sourceReportReferenceKey = e.dataTransfer.getData("reportReferenceKey");
                                                                let sourceGroupId = e.dataTransfer.getData("groupId");                                                                
            
                                                                onDrop({
                                                                    type: 3, 
                                                                    sourceReportIdAuto: sourceReportIdAuto, sourceReportId: sourceReportId, sourceReportTitle: sourceReportTitle, sourceReportReferenceKey: sourceReportReferenceKey, 
                                                                    targetReportIdAuto: item.Id, targetReportId: item.ReportId, sourceGroupId: sourceGroupId, targetGroupId: group.Id
                                                                });
                                                            }
                                                            else if (sourceType == "rightReport")
                                                            {
                                                                //insert right report into left report group before left report
                                                                let sourceReportId = e.dataTransfer.getData("reportId");
                                                                let sourceReportTitle = e.dataTransfer.getData("reportTitle");                                                                
                                                                let sourceReportReferenceKey = e.dataTransfer.getData("reportReferenceKey");

                                                                onDrop({
                                                                    type: 4, 
                                                                    sourceReportId: sourceReportId, sourceReportTitle: sourceReportTitle, sourceReportReferenceKey: sourceReportReferenceKey, 
                                                                    targetReportIdAuto: item.Id, targetReportId: item.ReportId, targetGroupId: group.Id});
                                                            }
                                                        }}>
                                                            <div className="title">{item.Title}</div>
                                                            <div className="remove">
                                                                <Button className="" style={{color: currentTheme.error}} icon="delete" fillMode="flat" onClick={e => onRemoveReport(item.Id, group.Id)} />
                                                            </div>
                                                        </div>
                                                    )                                                
                                                })
                                            }   
                                            </div>
                                        }
                                    </div>
                                );
                            })
                        }
                        </div>                        
                    </div>
                </div>
                <div className="description">
                    <span>{t("menudesigner.drop")} &amp; {t("menudesigner.drop2")}</span>
                </div>
                <div className="reports">
                    <div className="reports-inner">
                        <div className="header">
                            <div className="title">{t("menudesigner.reports")}</div>
                        </div>
                        <div className="reports-container">
                        {
                            reports.map((item, index) => {
                                return (
                                    <div key={item.Id} className="report-row" draggable="true" onDragStart={e => {
                                        e.dataTransfer.setData("sourceType", "rightReport");
                                        e.dataTransfer.setData("reportId", item.Id);
                                        e.dataTransfer.setData("reportTitle", item.Title);
                                        e.dataTransfer.setData("reportReferenceKey", item.ReferenceKey);
                                     }}>
                                        <div className={`k-icon k-i-circle`} style={{marginTop: 4, color: currentTheme.primary}}></div>
                                        <div className="title">{item.Title}</div>
                                    </div>
                                );
                            })
                        }                            
                        </div>
                    </div>
                </div>
            </div>            
            {
                addGroupState.isOpen &&
                <Dialog className="menu-designer-add-group-dialog" title={null}>
                    <KendoForm    
                            validator={onAddGroupValidate} 
                            key={addGroupState.formKey}
                            initialValues={addGroupState}
                            render={(formRenderProps) => {
                                return (
                                    <FormElement horizontal={false}
                                            style={{
                                                // width: 250,
                                            }}
                                    >                       
                                        <div className="toolbar">
                                            <Toolbar>
                                                <ToolbarItem>
                                                    <Button style={{color: currentTheme.primary}}  icon="save" onClick={onAddGroupSave}>
                                                        {t("menudesigner.save")}
                                                    </Button>
                                                </ToolbarItem>
                                                <ToolbarSeparator/>
                                                <ToolbarItem>
                                                    <Button  style={{color: currentTheme.primary}}  icon="cancel" onClick={onAddGroupClose}>
                                                        {t("menudesigner.cancel")}
                                                    </Button>
                                                </ToolbarItem>
                                            </Toolbar>            
                                        </div>
                                        <div className="form-content">  
                                            <div>
                                                <Field
                                                    id={"title"}
                                                    name={"title"}
                                                    label={t("menudesigner.title")}
                                                    component={FormInput}                                                     
                                                    onChange={ e => onAddGroupValueChange({id: "title", value: e.value}) }
                                                    maxLength={50}                                          
                                                    style={{width: "100%", marginTop:4}}
                                                    tabIndex={0}
                                                />     
                                            </div>
                                            <div style={{marginTop: 26}}>
                                                <Field
                                                    id={"icon"}
                                                    name={"icon"}
                                                    label={t("menudesigner.icon")}
                                                    component={FormDropDownListById}
                                                    data={iconsData} 
                                                    valueRender={iconValueRenderer}
                                                    itemRender={iconItemRenderer}
                                                    dataItemKey="Id" textField="Title"  
                                                    onChange={ e => onAddGroupValueChange({id: "icon", value: e.value}) }
                                                    style={{width: "100%", marginTop:4}}
                                                />     
                                            </div>
                                        </div>
                                    </FormElement>
                                );
                            }}
                        />
                </Dialog>
            }
            <style>
                {
                `
                    // .page > .content{
                    //     overflow-y: auto;
                    // }

                    .menu-designer
                    {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 24px;
                        height: calc(100% - 8px);
                    }

                    .menu-designer .groups
                    {
                        padding: 12px 24px 12px 12px;
                        width: 40%;
                        max-width: 800px;                       
                        height: calc(100% - 40px);
                        overflow-y:auto;
                    }

                    .menu-designer .groups-inner
                    {
                        display: flex;
                        flex-direction: column;
                        min-height: 300px;
                        border: 1px solid ${currentTheme.componentBorderColorDouble};
                        border-radius: 6px;
                        height: 100%;
                    }

                    .menu-designer .groups .header
                    {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 12px;
                        border-bottom: 1px solid ${currentTheme.componentBorderColorDouble};
                        margin-bottom: 4px;
                    }

                    .menu-designer .groups .header .title
                    {
                        font-size: 15px;
                        font-weight: 700;
                        align-items: center;
                        color: ${currentTheme.componentText};
                        margin-left: 8px;
                    }

                    .menu-designer .groups .header .add-group
                    {
                        font-size: 15px;
                        font-weight: 700;
                        color: ${currentTheme.primary};
                        margin-right: 8px;
                    }
                                        

                    .menu-designer .groups .header .add-group:hover
                    {
                        cursor: pointer;
                    }

                    .menu-designer .groups .groups-container
                    {
                        display: flex;
                        flex-direction: column;
                        padding-bottom: 6px;
                        flex: 1;
                        overflow-y: auto;
                    }

                    .menu-designer .groups .groups-container .group-container
                    {
                        margin-bottom: 5px;
                    }

                    .menu-designer .groups .group-row
                    {
                        border: 1px solid ${currentTheme.componentBorderColorDouble};
                        border-radius: 4px;
                        padding: 8px;
                        margin: 12px 12px 8px 12px;
                        display: flex;                        
                    }

                    .menu-designer .groups .group-row:hover
                    {
                        cursor: grab;
                    }

                    .menu-designer .groups .group-row .title
                    {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        padding: 0 24px 0 8px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        color: ${currentTheme.componentText};
                    }

                    .menu-designer .groups .items-container
                    {
                        display: flex;
                        flex-direction: column;
                    }

                    .menu-designer .groups .items-container .item-row
                    {
                        margin: 6px 12px 4px 48px;
                        border: 1px solid gray;
                        border-radius: 5px;
                        border: 1px solid ${currentTheme.componentBorderColorDouble};
                        padding: 6px;
                        display: flex;
                        align-items: center;                        
                    }

                    .menu-designer .groups .items-container .item-row:hover
                    {
                        cursor: grab;
                    }

                    .menu-designer .groups .item-row .title
                    {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        padding: 0 8px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        color: ${currentTheme.componentText};
                    }

                    .menu-designer .description
                    {
                        border: 1px solid ${currentTheme.componentBorderColorDouble};
                        border-radius: 6px;
                        width: 150px;
                        padding: 12px;
                        color: ${currentTheme.componentText};
                    }


                    .menu-designer .reports
                    {
                        display: flex;
                        flex-direction: column;
                        padding: 12px 12px 12px 24px;
                        width: 35%;
                        maximum-width: 600px;
                        height: calc(100% - 40px);
                        overflow-y:auto;
                    }

                    .menu-designer .reports-inner
                    {
                        display: flex;
                        flex-direction: column;
                        min-height: 300px;
                        border: 1px solid ${currentTheme.componentBorderColorDouble};
                        border-radius: 6px;
                        height: 100%;
                    }

                    .menu-designer .reports-inner .header
                    {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 12px;
                        border-bottom: 1px solid ${currentTheme.componentBorderColorDouble};
                        margin-bottom: 4px;
                    }

                    .menu-designer .reports .header .title
                    {
                        font-size: 15px;
                        font-weight: 700;
                        align-items: center;
                        color: ${currentTheme.componentText};
                        margin-left: 8px;
                    }


                    .menu-designer .reports .reports-container
                    {
                        display: flex;
                        flex-direction: column;
                        padding-bottom: 6px;
                        flex: 1;
                        overflow-y: auto;
                    }

                    .menu-designer .reports .report-row
                    {
                        border: 1px solid ${currentTheme.componentBorderColorDouble};
                        border-radius: 4px;
                        padding: 8px;
                        margin: 12px 12px 8px 12px;
                        display: flex;
                        
                    }

                    .menu-designer .reports .report-row:hover
                    {
                        cursor: grab;
                    }

                    .menu-designer .reports .report-row .title
                    {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        padding: 0 24px 0 8px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;   
                        color: ${currentTheme.componentText};                 
                    }


                    /*add group dialog */
                    .menu-designer-add-group-dialog
                    {
                        width:500px;
                        height: 500px;
                        left: calc(50% - 250px);
                        top: calc(50% - 250px);
                    }

                    .menu-designer-add-group-dialog .k-dialog-content
                    {
                        padding: 0 !important;
                    }

                    .menu-designer-add-group-dialog .k-dialog
                    {
                        min-width: 500px;
                        width: 500px;
                    }

                    .menu-designer-add-group-dialog .k-form
                    {
                        width: 100%;
                        height: 100%;
                    }

                    .menu-designer-add-group-dialog .k-form .form-content
                    {
                        padding: 12px 26px 28px 26px;
                    }

                    .menu-designer-add-group-dialog .toolbar .k-button
                    {
                        border: none;
                        background:transparent;
                    }
                    
                    .menu-designer-add-group-dialog .toolbar 
                    {
                        border-bottom: 1px solid ${currentTheme.separatorColor};
                    }

                    .menu-designer-add-group-dialog .toolbar .k-separator 
                    {
                        border-color: ${currentTheme.appBarLinkColor} !important;
                    }

                    @media (max-width: 1024px) {
                        .menu-designer {
                            align-items: stretch;
                            flex-direction: column;
                            height: auto;
                            min-height: 100%;
                            padding: 12px 16px calc(80px + env(safe-area-inset-bottom));
                        }

                        .menu-designer .groups,
                        .menu-designer .reports {
                            box-sizing: border-box;
                            height: auto;
                            max-width: none;
                            padding: 0;
                            width: 100%;
                        }

                        .menu-designer .groups-inner,
                        .menu-designer .reports-inner {
                            height: auto;
                            min-height: 0;
                        }

                        .menu-designer .groups-container,
                        .menu-designer .reports-container {
                            max-height: min(42dvh, 360px);
                        }

                        .menu-designer .description {
                            box-sizing: border-box;
                            margin: 12px 0;
                            text-align: center;
                            width: 100%;
                        }

                        .menu-designer .groups .group-row,
                        .menu-designer .reports .report-row {
                            margin-left: 8px;
                            margin-right: 8px;
                        }

                        .menu-designer .groups .items-container .item-row {
                            margin-left: 24px;
                            margin-right: 8px;
                        }

                        .menu-designer-add-group-dialog {
                            height: auto;
                            left: auto;
                            top: auto;
                            width: auto;
                        }

                        .menu-designer-add-group-dialog .k-dialog {
                            box-sizing: border-box;
                            min-width: 0;
                            width: min(500px, calc(100vw - 32px));
                            max-height: calc(100dvh - 32px);
                        }

                        .menu-designer-add-group-dialog .k-dialog-content {
                            overflow-y: auto;
                        }

                        .menu-designer-add-group-dialog .toolbar .k-toolbar {
                            flex-wrap: wrap;
                        }
                    }
                `
                }
            </style>
        </Fragment>
    )
};
